import './pull-to-right.scss';

import { VNode } from 'vue';
import { Component, Vue } from 'vue-property-decorator';

interface Point2D {
    x: number;
    y: number;
}

const PULL_THRESHOLD_IN_PIXEL = 20;

// this is used to detect if a vertical scroll is occuring.
// If this happens we cancel our translation and the browser
// will not trigger further event during the scroll transaction
const VERTICAL_OFFSET_THRESHOLD_IN_PIXEL = 5;

const NON_RETURN_RATIO = 0.8;

@Component({
    props: ['enabled'],
    template: require('./pull-to-right.html'),
})
export class PullToRight extends Vue {
    public $refs: {
        viewport: HTMLDivElement;
    };
    public $slots: {
        default: VNode[];
    };
    public enabled: boolean;
    public pulling = false;
    public origin: Point2D = { x: 0, y: 0 };
    public offset: Point2D = { x: 0, y: 0 };
    public nonReturnRatioReached = false;

    public onTouchStart(event: TouchEvent) {
        if (!this.enabled) {
            return;
        }

        const touch = event.touches[0];
        this.origin = {
            x: touch.screenX,
            y: touch.screenY,
        };
        this.pulling = false;
        this.nonReturnRatioReached = false;
    }

    public onTouchMove(event: TouchEvent) {
        if (!this.enabled) {
            return;
        }

        const changedTouch = event.changedTouches[0];
        this.offset = {
            x: changedTouch.screenX - this.origin.x,
            y: changedTouch.screenY - this.origin.y,
        };

        if (
            this.offset.x > PULL_THRESHOLD_IN_PIXEL ||
            (!this.pulling && Math.abs(this.offset.y) > VERTICAL_OFFSET_THRESHOLD_IN_PIXEL)
        ) {
            this.translateX(0);
            return;
        }

        this.pulling = true;

        const offset = Math.abs(Math.min(0, this.offset.x - PULL_THRESHOLD_IN_PIXEL));
        const ratio = offset / this.clientWidth();

        this.nonReturnRatioReached = ratio > NON_RETURN_RATIO;

        const elasticRatio = ratio * Math.pow(ratio, 2);
        const offsetX = -Math.min(this.clientWidth(), elasticRatio * offset);

        this.translateX(offsetX);
    }

    public onTouchEnd() {
        if (!this.enabled) {
            return;
        }

        if (this.nonReturnRatioReached) {
            this.translateX(-this.clientWidth());
            this.$emit('pulled');
            return;
        }

        this.translateX(0);
    }

    public reset() {
        this.translateX(0);
    }

    private translateX = (offsetX: number) => {
        const elements = this.$slots.default.filter(node => node.tag === 'div');
        if (elements && elements.length > 1) {
            (elements[0].elm as any).style.transform = `translate3d(${offsetX}px, 0, 0)`;
            (elements[1].elm as any).style.transform = `translate3d(${offsetX}px, 0, 0)`;
        }
    };

    private clientWidth = () => this.$refs.viewport.clientWidth;
}
